import React from 'react'
import NetherlandBloreCertMain from './NetherlandBloreCertMain'
import AustraliaBloreCertHead from "../../Australia/AustraliaBloreCert/AustraliaBloreCertHead";
import "./../../UaeAttestation/UaeService/UaeService.css";

const NetherlandBloreCert = () => {
  return (
    <div className="uaeServiceContainer">
      <AustraliaBloreCertHead head="NetherLands Apostille service in Bangalore for certificates" />
      <NetherlandBloreCertMain />
    </div>
  )
}

export default NetherlandBloreCert
